export default "__VITE_ASSET__9N89TsVc__"